<template>
  <div class="c-uploadImage">
    <div class="image__list clearfix">
      <div
        class="image__add"
        @click="addImage"
        v-show="limitNum > 1 || imageList.length == 0"
      ></div>
      <div class="image__itemwrap" v-for="(v, ind) in imageList" :key="v">
        <img class="image__item" :src="v" @click="showPreview(ind)" />
      </div>
    </div>
    <div
      class="preview__container"
      v-if="previewShow"
      @click="hidePreview($event)"
    >
      <div class="preview__image">
        <swipe
          :auto="0"
          class="swiper"
          :showIndicators="false"
          :defaultIndex="activeIndex"
          @change="(i) => (activeIndex = i)"
        >
          <swipeItem v-for="item in imageList" :key="item">
            <img :src="item" class="slide-image" />
          </swipeItem>
        </swipe>
      </div>
      <div class="preview__num">
        {{ activeIndex + 1 }}/{{ imageList.length }}
      </div>
      <div class="preview__delete" @click="deleteImage"></div>
    </div>
  </div>
</template>

<script>
import { appBridge } from '@/utils/common';
import { swipe, swipeItem } from './swipe';
export default {
  created() {
    window.addEventListener(
      'hashchange',
      () => {
        if (window.location.hash != '#preview') {
          this.previewShow = false;
        }
      },
      false
    );
  },
  components: {
    swipe,
    swipeItem
  },
  props: {
    limitNum: {
      type: Number,
      default: 5
    },
    imageList: {
      type: Array
    }
  },
  data() {
    return {
      previewShow: false,
      activeIndex: 0
    };
  },
  methods: {
    showPreview(index) {
      this.previewShow = true;
      window.location.hash = '#preview';
      this.activeIndex = index;
    },
    hidePreview(event) {
      if (/slide-image/.test(event.target.className)) {
        return;
      }
      this.previewShow = false;
      window.history.back();
    },
    deleteImage() {
      let list = [...this.imageList];
      list.splice(this.activeIndex, 1);
      this.$emit('update:imageList', list);
      if (!this.imageList.length) {
        this.previewShow = false;
        window.history.back();
      }
    },
    addImage() {
      let limit = this.limitNum - this.imageList.length;
      if (limit > 0) {
        appBridge.getAlbumPhoto({ limit: String(limit) }).then((res) => {
          let list = [];
          res.forEach((v, ind) => {
            list.push('data:image/png;base64,' + res[ind]);
          });
          this.$emit('update:imageList', [...this.imageList, ...list]);
        });
      }
    }
  }
};
</script>

<style>
.image__num {
  margin: 0.22rem 0 0.12rem;
}
.image__num span {
  color: #999;
}
.image__list {
}
.image__add {
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  background: url(~@/assets/image/account_icon_pic@2x.png) no-repeat 0 0 /
    0.6rem 0.6rem;
  margin-right: 0.19rem;
}
.image__itemwrap {
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  margin: 0 0.19rem 0.1rem 0;
}
.image__item {
  width: 0.6rem;
  height: 0.6rem;
  object-fit: cover;
}

.preview__container {
  background: rgba(0, 0, 0, 1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}
.preview__image {
  max-width: 80%;
  height: 90%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.preview__num {
  position: absolute;
  bottom: 0.3rem;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 0.12rem;
}
.preview__delete {
  position: absolute;
  top: 0.1rem;
  right: 0.12rem;
  width: 0.32rem;
  height: 0.32rem;
  background: url(~@/assets/image/account_navi_icon_delete_w@2x.png) no-repeat 0
    0 / 0.32rem 0.32rem;
}
.slide-image {
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
</style>
